import React from 'react'

const QuoteMgt = () => {
  return (
    <div>QuoteMgt</div>
  )
}

export default QuoteMgt